import React, { useState } from "react";
import { Col, Row, Collapse, Button } from "reactstrap";

const HelpItem = ({ heading, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <Col style={{ marginTop: "1rem" }}>
      <Row>
        <Button color="primary" onClick={toggle}>
          <strong>{heading}</strong>
        </Button>
      </Row>
      <Row style={{ marginTop: "1rem" }}>
        <Collapse isOpen={isOpen}>
          {children}
        </Collapse>
      </Row>
    </Col>
  );
};

export default HelpItem;